import { useState } from "react";
import { useI18n } from "@/i18n";
import type { Lang } from "@/i18n";

const LANGS: { code: Lang; flag: string; label: string }[] = [
  { code: "tr", flag: "🇹🇷", label: "Türkçe" },
  { code: "en", flag: "🇬🇧", label: "English" },
  { code: "de", flag: "🇩🇪", label: "Deutsch" },
  { code: "fr", flag: "🇫🇷", label: "Français" },
  { code: "es", flag: "🇪🇸", label: "Español" },
  { code: "ar", flag: "🇸🇦", label: "العربية" },
  { code: "ru", flag: "🇷🇺", label: "Русский" },
];

export function AuthLangSwitcher() {
  const { lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);
  const current = LANGS.find((l) => l.code === lang) || LANGS[0];

  return (
    <div className="fixed top-4 right-4 z-50">
      <button
        className="flex items-center gap-1.5 rounded-lg border bg-card px-3 py-2 text-sm shadow-sm hover:border-primary transition-colors"
        onClick={() => setOpen(!open)}
      >
        <span className="text-base">{current.flag}</span>
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="2" className="text-muted-foreground"><path d="M3 5l3 3 3-3"/></svg>
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 top-full mt-1 z-50 min-w-[160px] rounded-xl border bg-card shadow-lg overflow-hidden">
            {LANGS.map((l) => (
              <button
                key={l.code}
                className={`flex w-full items-center gap-3 px-4 py-2.5 text-sm transition-colors hover:bg-muted ${l.code === lang ? "bg-primary/10 text-primary font-semibold" : ""}`}
                onClick={() => { setLang(l.code); setOpen(false); }}
              >
                <span className="text-base">{l.flag}</span>
                {l.label}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
